<template>
    <Layout>
        <LogInAs />
    </Layout>
</template>

<script>
import Layout from './Layout'
import LogInAs from './Buttons/LogInAs'
import { mapState, mapGetters } from 'vuex'

export default {
    components: {
        Layout,
        LogInAs,
    },
}
</script>